import React, { useState, useEffect, useContext, useRef } from "react";

import "./Home.css";
import generator from "../../assets/generator.png";
import cash from "../../assets/cash.png";
import camry from "../../assets/camry.png";
import airtime from "../../assets/airtime.png";
import Navbar from "../../components/Navbar/Navbar";
import dubaiTrip from "../../assets/dubai-trip.png";

import axios from "axios";
import Loader from "../../components/Loader/loader";
import Otp from "../../components/Otp/Otp";
import CookieConsent, {
  Cookies,
  getCookieConsentValue,
} from "react-cookie-consent";

import { sendOtpURL, confirmOtpURL, RegisterEndpoint, LoginEndpoint } from "../../Utils/apis";

import { notification } from "antd";

import { Redirect, useHistory } from "react-router-dom";
import { PlayContext } from "../../App";

const Home = () => {
  const slideImages = [generator, airtime, cash, camry, dubaiTrip];
  const [currentImg, setCurrentImg] = useState(generator);
  const [loginPage, setLoginPage] = useState(true);
  const myRef = useRef(null);

  const executeScroll = () =>
    myRef.current.scrollIntoView({ behavior: "smooth" });

  const checkIsAuthenticated = () => {
    const token = localStorage.getItem("authed");
    setState({ authed: token });
    console.log(state, token);
  };

  const history = useHistory();
  const { open, toggleOpen } = useContext(PlayContext);

  const toggleNotification = () => {
    const args = {
      message: "Access Blocked",
      description: "Please login before you can proceed",
      duration: 8,
    };
    notification.open(args);
    executeScroll();
  };

  useEffect(() => {
    checkIsAuthenticated();
    console.log(checkIsAuthenticated);
    const token = localStorage.getItem("authed");
    setState({ authed: token });
    console.log(state);
    setInterval(() => {
      setCurrentImg(
        slideImages[Math.floor(Math.random() * slideImages.length)]
      );
    }, 5000);
  }, [setInterval]);
  const [state, setState] = useState({
    authed: "notAuthenticated",
    // authed: false,
    msisdn: "",
    network: "",
    password: "",
    confirmPassword: "",
    email: "",
    otp: "",
    wrongNum: false,
    showOtp: false,
    wrongOtp: false,
    isLoading: false,
    authenticated: false,
  });

  const addToLocalStorage = (msisdn, network) => {
    localStorage.setItem("msisdn", msisdn);
    localStorage.setItem("network", network);
  };

  const isAuthenticated = (authed) => {
    localStorage.setItem("authed", "authenticated");
  };
  const logged_in_number = state.msisdn;

  const onChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
      showOtp: false,
    });
  };

  const onOTPChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const checkLength = () => {
    var long = document.getElementById("phoneNumber").value;
    var len = long.length;
    if (len !== 11) {
      setState({
        ...state,
        wrongNum: true,
      });
    } else {
      setState({
        ...state,
        wrongNum: false,
      });
    }
  };

  const openNotification = () => {
    const args = {
      message: "One-Time-Password",
      description:
        "Check your SMS. Input the sent OTP, OTP is valid For 24 hours.",
      duration: 10,
    };
    notification.open(args);
  };

  const openConfirmNotification = () => {
    const args = {
      message: "OTP validation successful",
      description: "You can Now Proceed to make a spin",
      duration: 10,
    };
    notification.open(args);
  };

  const openErrorNotification = () => {
    const args = {
      message: "Error",
      description: "An Error Occoured",
      duration: 10,
    };
    notification.open(args);
  };

  const openCustomErrorNotification = (msg) => {
    const args = {
      message: "Error",
      description: msg,
      duration: 10,
    };
    notification.open(args);
  };

  const sendOTP = () => {
    addToLocalStorage(msisdn, network);
    setState({
      ...state,
      isLoading: true,
    });
    axios({
      method: "post",
      url: sendOtpURL,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        msisdn,
        network,
        email,
      },
    })
      .then(function (result) {
        console.log(result);
        if (
          result.status === 200 &&
          result.data.status === "OtpDuplicationError"
        ) {
          setState({
            ...state,
            showOtp: true,
            isLoading: false,
          });
          openCustomErrorNotification(result.data.message);
        }
        if (result.status === 200 && result.data.status === "success") {
          setState({
            ...state,
            showOtp: true,
            isLoading: false,
          });
          openNotification();
        }
      })
      .catch((error) => {
        console.log(error);
        setState({
          ...state,
          isLoading: false,
        });
      });
  };

  const Login = () => {
    setState({
      ...state,
      isLoading: true,
    });
    axios({
      method: "post",
      url: LoginEndpoint,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        email,
        password,
      },
    })
      .then(function (result) {
        console.log(result.data)
        if ((result.status = 200)) {
          setState({
            ...state,
            showOtp: true,
            isLoading: false,
            authed: true,
          });
          toggleOpen();
          localStorage.setItem("authed", "authenticated");
          localStorage.setItem("token", result.data.token);
          localStorage.setItem("msisdn", result.data.user.msisdn );
          localStorage.setItem("email", result.data.user.username );
          // toggleOpen();
          openConfirmNotification();
        }
      })
      .catch((error) => {
        console.log(error);
        openCustomErrorNotification("Invalid Login Details");
        setState({
          ...state,
          isLoading: false,
        });
      });
  };

  const Register = () => {
    if (password !== confirmPassword) {
      return openCustomErrorNotification("passwords donot match");
    }
    setState({
      ...state,
      isLoading: true,
    });
    axios({
      method: "post",
      url: RegisterEndpoint,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        email,
        network,
        msisdn,
        password,
      },
    })
      .then(function (result) {
        console.log(result.data)
        if ((result.status = 200)) {
          setState({
            ...state,
            showOtp: true,
            isLoading: false,
            authed: true,
          });
          toggleOpen();
          localStorage.setItem("authed", "authenticated");
          localStorage.setItem("token", result.data.token);
          localStorage.setItem("msisdn", result.data.user.msisdn );
          localStorage.setItem("email", result.data.user.username );
          // toggleOpen();
          openConfirmNotification();
        }
      })
      .catch((error) => {
        console.log(error);
        openCustomErrorNotification("An error occoured");
        setState({
          ...state,
          isLoading: false,
        });
      });
  };

  const {
    email,
    password,
    confirmPassword,
    msisdn,
    network,
    otp,
    isLoading,
    wrongNum,
    showOtp,
    authed,
    authenticated,
  } = state;

  if (localStorage.getItem("authed") == "authenticated") {
    return <Redirect to="/play" />;
  }
  return (
    <>
      <Navbar />
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-4 order-1 order-sm-2 ">
            <h2 className="header-text-mobile pt-5"> SPIN TO WIN</h2>
            <h2 className="header-text-mobile">AMAZING PRIZES</h2>
            <div className=""></div>

            <h6 className="text-white mt-5 text-center">
              {/* Enter your number below and spin the wheel to be our next lucky
              winner */}
              {/* Register Now To become elidgible to win amazing prizes  */}
            </h6>

            {/* <Form /> */}
            {/*  */}
            <form class="border p-3 rounded">
              {loginPage ? (
                <>
                  <label className="form-label" for="name">
                    EMAIL
                  </label>
                  <input
                    // type="text"
                    className="my-select"
                    icon="phone"
                    type="email"
                    id="email"
                    onChange={onChange}
                    required
                    name="email"
                    value={email}
                  />
                  <label className="form-label" for="name">
                    PASSWORD
                  </label>
                  <input
                    // type="text"
                    className="my-select"
                    icon="phone"
                    type="password"
                    id="password"
                    onChange={onChange}
                    required
                    name="password"
                    value={password}
                  />
                  <button
                    className="button-submit btn-block p-3"
                    type="button"
                    onClick={Login}
                  >
                    {isLoading ? <Loader /> : "Login"}
                  </button>
                  <a className="text-white text-center">
                    Dont have an account ?{" "}
                    <span onClick={(e) => setLoginPage(false)}>Register</span>
                  </a>
                </>
              ) : (
                <>
                  <label className="form-label" for="name">
                    PHONE NUMBER
                  </label>
                  <input
                    // type="text"
                    className="my-select"
                    icon="phone"
                    type="number"
                    id="phoneNumber"
                    onBlur={checkLength}
                    onChange={onChange}
                    required="required"
                    name="msisdn"
                    value={msisdn}
                  />
                  <span
                    className="error text-danger ml-1 bg-light"
                    style={{ display: wrongNum ? "block" : "none" }}
                  >
                    Invalid Phone Number
                  </span>
                  <label className="form-label" for="job" ref={myRef}>
                    NETWORK
                  </label>
                  <br></br>
                  <select
                    className="my-select"
                    id="network"
                    name="network"
                    value={network}
                    onChange={onChange}
                    required
                  >
                    <option value="" disabled selected hidden>
                      select network
                    </option>
                    <option value="9mobile">9mobile</option>
                    <option value="mtn">mtn</option>
                    <option value="glo">glo</option>
                    <option value="airtel">airtel</option>
                  </select>

                  <label className="form-label" for="name">
                    EMAIL
                  </label>
                  <input
                    // type="text"
                    className="my-select"
                    icon="phone"
                    type="email"
                    id="email"
                    onChange={onChange}
                    required
                    name="email"
                    value={email}
                  />

                  <label className="form-label" for="name">
                    PASSWORD
                  </label>
                  <input
                    // type="text"
                    className="my-select"
                    icon="phone"
                    type="password"
                    id="password"
                    onChange={onChange}
                    required
                    name="password"
                    value={password}
                  />
                  <label className="form-label" for="name">
                    CONFIRM PASSWORD
                  </label>
                  <input
                    // type="text"
                    className="my-select"
                    icon="phone"
                    type="password"
                    id="confirmPassword"
                    onChange={onChange}
                    required
                    name="confirmPassword"
                    value={confirmPassword}
                  />
                  <br></br>
                  <button
                    className="button-submit btn-block p-3"
                    type="button"
                    onClick={Register}
                  >
                    {isLoading ? <Loader /> : "Register"}
                  </button>
                  <a className="text-white text-center">
                    Already have an account ?{" "}
                    <span onClick={(e) => setLoginPage(true)}>Login</span>
                  </a>
                </>
              )}
            </form>
          </div>
          <div className="col-sm-12  order-2 col-md-2"></div>
          <div className="order-sm-12 col-md-5 mobileHide pull-right">
            <img
              onClick={toggleNotification}
              className="imgA1 mb-5 pb-5"
              src={currentImg}
              alt="Logo"
            />
          </div>
        </div>
        <CookieConsent
          overlay
          location="bottom"
          buttonText="Accept"
          declineButtonText="Decline"
          cookieName="spinwheelCookie"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
          onAccept={() => {
            alert("Accept was triggered by clicking the Accept button");
            console.log(getCookieConsentValue());
          }}
          enableDeclineButton
          onDecline={() => {
            alert("nay!");
          }}
        >
          This website uses cookies to enhance the user experience.{" "}
          <span style={{ fontSize: "10px" }}>
            {/* This bit of text is smaller :O */}
          </span>
        </CookieConsent>
      </div>
    </>
  );
};

export default Home;
